(function() {
  'use strict';
  
  function generateToken() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  }
  
  function addWatermark(canvas, ctx) {
    var watermarkText = 'copyright © www.ceayabikes.com';
    ctx.textBaseline = 'middle';
    
    function measureText(fontSize) {
      ctx.font = 'bold ' + fontSize + 'px Arial';
      return ctx.measureText(watermarkText).width;
    }
    
    function calculateOptimalFontSize(maxWidth, maxHeight) {
      var fontSize = Math.min(maxWidth / watermarkText.length * 1.5, maxHeight / 2, 50);
      var measured = measureText(fontSize);
      while (measured > maxWidth * 0.9 && fontSize > 10) {
        fontSize -= 2;
        measured = measureText(fontSize);
      }
      return Math.max(fontSize, 12);
    }
    
    var patternSize = Math.min(canvas.width / 2.5, canvas.height / 2.5, 180);
    var patternFontSize = calculateOptimalFontSize(patternSize * 0.85, patternSize * 0.35);
    var angle = -Math.PI / 6;
    var offsets = [0, patternSize / 2];
    
    ctx.save();
    ctx.font = 'bold ' + patternFontSize + 'px Arial';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.lineWidth = Math.max(1.5, patternFontSize / 15);
    ctx.textAlign = 'center';
    
    for (var i = 0; i < offsets.length; i++) {
      for (var j = 0; j < offsets.length; j++) {
        for (var x = offsets[i]; x < canvas.width + patternSize; x += patternSize) {
          for (var y = offsets[j]; y < canvas.height + patternSize; y += patternSize) {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(angle);
            ctx.strokeText(watermarkText, 0, 0);
            ctx.fillText(watermarkText, 0, 0);
            ctx.restore();
          }
        }
      }
    }
    ctx.restore();
    
    var centerFontSize = calculateOptimalFontSize(canvas.width * 0.7, canvas.height * 0.25);
    ctx.save();
    ctx.font = 'bold ' + centerFontSize + 'px Arial';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.75)';
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.65)';
    ctx.lineWidth = Math.max(2.5, centerFontSize / 12);
    ctx.textAlign = 'center';
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(angle);
    ctx.strokeText(watermarkText, 0, 0);
    ctx.fillText(watermarkText, 0, 0);
    ctx.restore();
  }
  
  function createWatermarkedImage(img, callback) {
    if (!img) {
      callback(null);
      return;
    }
    
    function processImage(sourceImg) {
      try {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var width = sourceImg.naturalWidth || sourceImg.width;
        var height = sourceImg.naturalHeight || sourceImg.height;
        
        if (width <= 0 || height <= 0) {
          callback(null);
          return;
        }
        
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(sourceImg, 0, 0, width, height);
        addWatermark(canvas, ctx);
        canvas.toBlob(function(blob) {
          callback(blob || null);
        }, 'image/png', 0.95);
      } catch (e) {
        callback(null);
      }
    }
    
    if (img.complete && img.naturalWidth > 0) {
      processImage(img);
    } else {
      var imgSrc = img.src || img.currentSrc || img.dataset.src;
      if (!imgSrc) {
        callback(null);
        return;
      }
      var watermarkImg = new Image();
      watermarkImg.crossOrigin = 'anonymous';
      watermarkImg.onload = function() {
        processImage(watermarkImg);
      };
      watermarkImg.onerror = function() {
        if (img.complete && img.naturalWidth > 0) {
          processImage(img);
        } else {
          callback(null);
        }
      };
      watermarkImg.src = imgSrc;
    }
  }
  
  function downloadWatermarkedImage(img) {
    createWatermarkedImage(img, function(blob) {
      if (!blob) return;
      
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'image-' + generateToken() + '.png';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 100);
    });
  }
  
  function preventAllDrag(e) {
    var target = e.target;
    var isImg = target.tagName === 'IMG';
    var hasImg = target.closest && target.closest('img');
    var containsImg = target.querySelector && target.querySelector('img');
    
    if (isImg || hasImg || containsImg || target.tagName === 'PICTURE' || 
        (target.tagName === 'A' && (target.href && (target.href.match(/\.(webp|jpg|jpeg|png|gif)/i) || target.querySelector('img'))))) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'none';
        e.dataTransfer.dropEffect = 'none';
      }
      return false;
    }
  }
  
  function disableImageDrag(img) {
    if (!img || img.tagName !== 'IMG') return;
    img.setAttribute('draggable', 'false');
    img.style.webkitUserDrag = 'none';
    img.ondragstart = function() { return false; };
    var link = img.closest && img.closest('a');
    if (link) {
      link.setAttribute('draggable', 'false');
      link.ondragstart = function() { return false; };
    }
  }
  
  function initAllImages() {
    document.querySelectorAll('img').forEach(disableImageDrag);
    document.querySelectorAll('a').forEach(function(link) {
      if (link.querySelector('img') || (link.href && link.href.match(/\.(webp|jpg|jpeg|png|gif)/i))) {
        link.setAttribute('draggable', 'false');
        link.ondragstart = function() { return false; };
      }
    });
  }
  
  initAllImages();
  
  new MutationObserver(initAllImages).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'data-src', 'srcset']
  });
  
  document.addEventListener('dragstart', preventAllDrag, true);
  document.addEventListener('drag', preventAllDrag, true);
  document.addEventListener('dragend', preventAllDrag, true);
  
  document.addEventListener('mousedown', function(e) {
    var img = e.target.tagName === 'IMG' ? e.target : (e.target.closest && e.target.closest('img'));
    if (img) disableImageDrag(img);
  }, true);
  
  var touchData = { time: 0, img: null, x: 0, y: 0, moved: false, link: null, preventClick: false };
  
  document.addEventListener('touchstart', function(e) {
    var img = e.target.tagName === 'IMG' ? e.target : (e.target.closest && e.target.closest('img'));
    var link = img && img.closest ? img.closest('a') : null;
    if (img && (img.src || img.currentSrc || img.dataset.src)) {
      touchData.time = Date.now();
      touchData.img = img;
      touchData.link = link;
      touchData.moved = false;
      touchData.preventClick = false;
      if (e.touches && e.touches.length > 0) {
        touchData.x = e.touches[0].clientX;
        touchData.y = e.touches[0].clientY;
      }
    } else {
      touchData.img = null;
      touchData.link = null;
    }
  }, { passive: true });
  
  document.addEventListener('touchmove', function(e) {
    if (touchData.img && e.touches && e.touches.length > 0) {
      if (Math.abs(e.touches[0].clientX - touchData.x) > 10 || 
          Math.abs(e.touches[0].clientY - touchData.y) > 10) {
        touchData.moved = true;
      }
    }
  }, { passive: true });
  
  document.addEventListener('touchend', function(e) {
    if (touchData.img && !touchData.moved) {
      var touchDuration = Date.now() - touchData.time;
      var link = touchData.link;
      if (touchDuration > 800) {
        e.preventDefault();
        e.stopPropagation();
        touchData.preventClick = true;
        downloadWatermarkedImage(touchData.img);
        if (link) {
          link.style.pointerEvents = 'none';
          setTimeout(function() {
            link.style.pointerEvents = '';
          }, 100);
        }
      }
    }
    touchData.img = null;
    touchData.link = null;
    touchData.moved = false;
  }, { passive: false });
  
  document.addEventListener('click', function(e) {
    if (touchData.preventClick) {
      e.preventDefault();
      e.stopPropagation();
      touchData.preventClick = false;
    }
  }, true);
  
  document.addEventListener('contextmenu', function(e) {
    var img = e.target.tagName === 'IMG' ? e.target : (e.target.closest && e.target.closest('img'));
    var link = img && img.closest ? img.closest('a') : null;
    if (img || link) {
      e.preventDefault();
      if (img && (img.src || img.currentSrc || img.dataset.src)) {
        downloadWatermarkedImage(img);
      }
    }
  }, true);
})();
